import React from 'react';
import { View, StyleSheet } from 'react-native';

import OPComponent from '../op_component';
import ValidatedComponent from './validated_comp';

import Select from 'react-select';

import {
  SELECT_STYLE,
  SELECT_STYLE_DISABLED,
  SELECT_STYLE_GREYED_OUT,
} from '../../../constants/styles';

export default class WebSelect extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      requiredError: false,
      validateError: false,
    };

    this._validatedRef = React.createRef();
  }

  validate() {
    return this._validatedRef.current?.validate();
  }

  handleFocus = () => {
    this.setState({ active: true });
    this.props.onFocus?.();
  };

  handleBlur = () => {
    this.setState({ active: false });
    this.props.onBlur?.();
  };

  render() {
    const props = this.props;
    const notEditable = this.props.editable === false;
    const styles = {
      ...(props.styles || SELECT_STYLE),
      ...(notEditable ? SELECT_STYLE_DISABLED : null),
      ...(this.props.disabled ? SELECT_STYLE_GREYED_OUT : null),
    };
    return (
      <ValidatedComponent
        ref={this._validatedRef}
        style={[props.containerStyle || styles.container, { zIndex: this.state.active ? 1000 : 0 }]}
        testID={props.label}
        {...this.props}
      >
        <View style={[{ marginBottom: 10, marginTop: 5, zIndex: 100 }, props.selectContainerStyle]}>
          <Select
            styles={styles}
            options={props.options}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={props.onValue}
            defaultValue={props.value}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.id}
            menuPlacement={props.menuPlacement || 'auto'}
            menuPortalTarget={props.menuPortalTarget}
            value={props.value}
            isDisabled={notEditable}
            placeholder={props.placeholder}
            isClearable={props.isClearable}
            testID={props.label}
          />
        </View>
      </ValidatedComponent>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});
